import { render, staticRenderFns } from "./studentAttendanceList.vue?vue&type=template&id=628950fa&scoped=true&"
import script from "./studentAttendanceList.vue?vue&type=script&lang=js&"
export * from "./studentAttendanceList.vue?vue&type=script&lang=js&"
import style0 from "./studentAttendanceList.vue?vue&type=style&index=0&id=628950fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628950fa",
  null
  
)

export default component.exports